import PropTypes from 'prop-types';

export default {
  pageTitle: PropTypes.string.isRequired,
};
